if (!customElements.get('yc-swiper-products')) {
  class YcSwiperProducts extends HTMLElement {
    connectedCallback() {
      const [arrowLeft, arrowRight] = this.querySelectorAll('.yc-swiper-products__button');
      const content = this.querySelector('.yc-swiper-products__content');

      if (!content || !arrowLeft || !arrowRight) return;

      this._eventController?.abort();
      this._eventController = new AbortController();
      const listenerOptions = { signal: this._eventController.signal };
      const arrows = [arrowLeft, arrowRight];
      const flags = arrows.map((arrow) => arrow.closest('.yc-swiper-products__flag'));

      const getScrollStep = () => {
        const firstItem = content.querySelector('.yc-swiper-products__item');
        const gap = Number.parseFloat(getComputedStyle(content).columnGap) || 0;
        return firstItem ? firstItem.getBoundingClientRect().width + gap : 0;
      };

      const updateNavigation = () => {
        const itemCount = content.querySelectorAll('.yc-swiper-products__item').length;
        const isDesktop = window.matchMedia('(min-width: 801px)').matches;
        const hasOverflow = content.scrollWidth - content.clientWidth > 1;
        const showArrows = isDesktop ? itemCount > 3 : hasOverflow;
        const maxScrollLeft = Math.max(0, content.scrollWidth - content.clientWidth);

        flags.forEach((flag) => {
          if (flag) flag.hidden = !showArrows;
        });

        arrowLeft.disabled = !showArrows || content.scrollLeft <= 1;
        arrowRight.disabled = !showArrows || content.scrollLeft >= maxScrollLeft - 1;
      };

      arrowLeft.addEventListener('click', () => {
        content.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      }, listenerOptions);

      arrowRight.addEventListener('click', () => {
        content.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      }, listenerOptions);

      this._scrollHandler = () => window.requestAnimationFrame(updateNavigation);
      content.addEventListener('scroll', this._scrollHandler, { passive: true, signal: this._eventController.signal });

      this._resizeHandler = updateNavigation;
      window.addEventListener('resize', this._resizeHandler, listenerOptions);

      this._resizeObserver = new ResizeObserver(updateNavigation);
      this._resizeObserver.observe(content);

      updateNavigation();
      this.fetchRecommendations(content).finally(updateNavigation);
    }

    disconnectedCallback() {
      this._eventController?.abort();
      this._resizeObserver?.disconnect();
    }

    fetchRecommendations(Content) {
      const isRecommended = this.getAttribute('data-source') === 'recommended';
      const sectionId = this.getAttribute('data-section-id');
      const productId = this.getAttribute('data-product-id');
      const limit = this.getAttribute('data-limit');
      const recommendationsUrl = this.getAttribute('data-recommendations-url');

      if (isRecommended && productId && recommendationsUrl) {
        const url = `${recommendationsUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
        return fetch(url)
          .then(response => response.text())
          .then(text => {
            let parse = document.createElement('div');
            parse.innerHTML = text;
            const parsedContent = parse.querySelector('.yc-swiper-products__content');

            if (parsedContent && parsedContent.innerHTML) {
              Content.innerHTML = parsedContent.innerHTML;
            }
          })
          .catch(e => console.error('Failed to fetch recommendations', e));
      }

      return Promise.resolve();
    }
  }

  customElements.define('yc-swiper-products', YcSwiperProducts);
}
